import React from "react";
import { ListItemButton, ListItemIcon, ListItemText } from "@mui/material";
import { useNavigate } from "react-router-dom";

interface ISidebarItem {
  text: string;
  Icon?: React.ElementType;
  active?: boolean;
  href?: string;
}

function SidebarItem({ text, Icon, active, href }: ISidebarItem) {
  const navigate = useNavigate();
  return (
    <ListItemButton
      onClick={() => navigate(href as string)}
      sx={
        active
          ? {
              px: 2,
              py: 1,
              height: "45px",
              borderRadius: "10px",
              color: "common.white",
              backgroundColor: "primary.main",
              "&:hover": {
                color: "common.white",
                backgroundColor: "primary.main",
              },
            }
          : {
              px: 2,
              py: 1,
              height: "45px",
              borderRadius: "10px",
              color: "text.primary",
              "&:hover": {
                color: "primary.main",
                backgroundColor: "primary.600",
              },
            }
      }
    >
      <ListItemIcon sx={{ minWidth: "unset", width: "40px", color: "inherit" }}>
        {Icon && <Icon size={20} />}
      </ListItemIcon>
      <ListItemText primary={text} />
    </ListItemButton>
  );
}

export default SidebarItem;
